import { render, staticRenderFns } from "./RiskProduct.vue?vue&type=template&id=5dc214dd&"
import script from "./RiskProduct.vue?vue&type=script&lang=js&"
export * from "./RiskProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports